import gsap from 'gsap'
import Maqueta from '../Maqueta'
import Hotspots from './Hotspots'
import Interaccion from "./Interaccion"

export default class Cercanias {
    constructor() {
        this.maqueta = new Maqueta()
        this.camara = this.maqueta.camara.instancia
        this.controles = this.maqueta.camara.controles
        this.hotspots = new Hotspots()
        this.crearSelectores()
        this.toggleCercanias()
    }
    crearSelectores() {
        this.btnCercanias = document.getElementById('btnCercanias')
        this.modalCercanias = document.getElementById('modal-cercanias')
        this.inputsCercanias =  this.modalCercanias.querySelectorAll('input')      
        this.hwCercanias = document.querySelector('.hw-cercanias')
        this.hwVias = document.querySelector('.hw-vias')
        this.btnCercanias.addEventListener('click', this.mostrarInfo)

        this.modalCercanias.querySelector('.btnCerrar-modal').addEventListener('click', this.ocultarInfo)
    }
    toggleCercanias() {
        this.inputsCercanias.forEach(input => {
            input.addEventListener('click', ()=>{
                const categoria = input.id,
                    hotspotsConCategoria = document.querySelectorAll(`[data-categoria="${categoria}"]`)
                    console.log(categoria, hotspotsConCategoria)
                    
                if(input.checked) {
                    hotspotsConCategoria.forEach(hs => hs.classList.remove('oculto'))
                    //if(categoria === 'cerc-vias') this.maqueta.mundo.vias.modelo.visible = true
                } else {
                    hotspotsConCategoria.forEach(hs => hs.classList.add('oculto'))
                    //if(categoria === 'cerc-vias') this.maqueta.mundo.vias.modelo.visible = false
                }
                

            })
        })
    }

    mostrarInfo = () => {
        this.maqueta.mostrarCercanias = true
        this.hwCercanias.classList.add('activo')
        this.hwVias.classList.add('activo')
        //this.maqueta.mundo.vias.modelo.visible = true
        //console.log(this.maqueta.mundo.vias.modelo)
        this.inputsCercanias.forEach(input => { input.checked = true })
        this.hwCercanias.querySelectorAll('.hotspot').forEach(hotspot => { hotspot.classList.remove('oculto') })
        this.hwVias.querySelectorAll('.hotspot').forEach(hotspot => { hotspot.classList.remove('oculto') })

        const controles = this.controles
        controles.enabled = false
        gsap.to(this.camara.position, {
            duration: 1,
            x: -8.5,
            y: 4.01,
            z: 4.2,
            onUpdate: function () {
                controles.update()
            },
            onComplete: function () {
                controles.enabled = true
            }
        })
    }
    ocultarInfo = () => {
        this.hwCercanias.classList.remove('activo')
        this.hwVias.classList.remove('activo')
        //this.maqueta.mundo.vias.modelo.visible = false
        this.inputsCercanias.forEach(input => { input.checked = false })
        this.hwCercanias.querySelectorAll('.hotspot').forEach(hotspot => { hotspot.classList.add('oculto') })
        this.hwVias.querySelectorAll('.hotspot').forEach(hotspot => { hotspot.classList.add('oculto') }) 
        
        this.maqueta.mostrarCercanias = false
        
    }
}